import React, { Component } from 'react';
import ManageNotificationsForm from '../../../components/SiteAdmin/ManageNotificationsForm';
import ScheduledNotificationTable from '../../../components/SiteAdmin/ManageNotificationsForm/ScheduledNotificationTable';
import EditScheduledNotificationModal from '../../../components/SiteAdmin/ManageNotificationsForm/EditScheduledNotificationModal';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ManageNotifications.css';
import cx from 'classnames';
import getSiteSettings from './getSiteSettings.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
import getAllLocationsAdmin from './getAllLocationsAdmin.graphql';

export class ManageNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingNotification: null,
      showEditModal: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleEdit(notification) {
    this.setState({ editingNotification: notification, showEditModal: true });
  }

  handleCloseModal() {
    this.setState({ showEditModal: false, editingNotification: null });
  }

  render() {
    const { getSiteSettings: { loading }, getAllLocationsAdmin } = this.props;
    const { editingNotification, showEditModal } = this.state;

    const locations = getAllLocationsAdmin?.getAllLocationsAdmin?.results || [];

    return (
      <div>
        {!loading && (
          <div className={s.root}>
            <div className={s.container}>
              <div className={cx(s.heading, 'textAlignRightRTL')}>
                <FormattedMessage {...messages.manageNotifications} />
              </div>

              <div>
                <ManageNotificationsForm locations={locations} />
              </div>

              <ScheduledNotificationTable onEdit={this.handleEdit} />

              <EditScheduledNotificationModal
                show={showEditModal}
                notification={editingNotification}
                onClose={this.handleCloseModal}
                locations={locations}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: {
      fetchPolicy: 'network-only',
    },
  }),
  graphql(getAllLocationsAdmin, {
    name: 'getAllLocationsAdmin',
    options: {
      variables: {
        currentPage: 1,
        searchList: '',
      },
      fetchPolicy: 'network-only',
    },
  })
)(ManageNotifications);
